import { Component, OnInit, forwardRef, ViewChild, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { MultiSiteService } from '~/services/modules/common/multi-site.service';
import { SecurityService } from '~/services/security.service';
import { SitesEnum } from '~/shared/enums/sites.enum';

@Component({
    selector: 'sites-dropdown',
    templateUrl: './sites-dropdown.component.html',
    styleUrls: ['./sites-dropdown.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SitesDropdownComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SitesDropdownComponent implements OnInit, ControlValueAccessor {
  _sites: any[] = [];
  _sitesFiltered: any[] = [];

  @Input() placeholder: string = 'Choose a Site';
  @Input() inputClass: string = 'current-step';
  @Input() required: boolean = false;
  @Input() suggest: boolean = true;
  @Input() textField: string = 'name';
  @Input() valueField: string = 'id';
  @Input() showAllSites: boolean = true;
  @Input() disabled: boolean = false;
  @Input() layout: 'form-group' | 'row' | 'transaction' | 'none' = 'none';
  @Input() labelText: string = 'Site Code';
  @Input() inputContainerClass: string = '';
  @Input() forceShow: boolean = null;
  @Output() siteChanged = new EventEmitter<any>();

  @ViewChild('kendo_combo_sites') kendoComboSites: ComboBoxComponent;

  _value: any = null;
  isDisabled: boolean = false;
  _currentUser: any = null;
  isLoggedInAllSites: boolean = false;

  get showDropdown(): boolean {
    if (this.forceShow !== null && this.forceShow !== undefined) {
      return this.forceShow;
    }
    return (this.isLoggedInAllSites);
  }

  onChange: any = () => { };
  onTouch: any = () => { };

  constructor(
    private _multiSiteService: MultiSiteService,
    private _securityService: SecurityService
  ) {
    this._currentUser = this._securityService.currentUser;
  }

  ngOnInit(): void {
    this._checkAllSites();
    this._loadSites();
  }

  _loadSites() {
    this._multiSiteService.getAllSites().subscribe((data: any) => {
      let sites = Array.isArray(data) ? data : (data?.body ?? data?.data ?? []);
      if (!this.showAllSites) {
        sites = sites.filter((s: any) => s.id !== SitesEnum.AllSites); // 2 is SitesEnum.AllSites
      }
      this._sites = sites;
      this._sitesFiltered = this._sites;
    });
  }

  _handleSitesFilter(value: any) {
    if (!value) {
      this._sitesFiltered = this._sites;
    } else {
      this._sitesFiltered = this._sites.filter(
        (s: any) => {
          const text = s[this.textField] || '';
          return text.toLowerCase().indexOf(value.toLowerCase()) !== -1;
        }
      );
    }
  }

  writeValue(value: any): void {
    this._value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  _onValueChange(value: any) {
    this._value = value;
    this.onChange(value);
    this.onTouch();
    this.siteChanged.emit(value);
  }

  toggle(show: boolean) {
    if (this.kendoComboSites) {
      this.kendoComboSites.toggle(show);
    }
  }

  focus() {
    if (this.kendoComboSites) {
      this.kendoComboSites.focus();
    }
  }

  _checkAllSites() {
    const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? '';
    if (loggedInAccountSites !== '') {
      const site = JSON.parse(loggedInAccountSites)[0];
      this.isLoggedInAllSites = site.siteId === SitesEnum.AllSites;
    }
  }
}
